function printContent() {
    // フォームデータを取得して印刷用HTMLを作成
    const printArea = document.getElementById('printableArea').cloneNode(true);
    const inputs = printArea.querySelectorAll('input, textarea');

    inputs.forEach(function(input) {
        if (input.type === 'radio' || input.type === 'checkbox') {
            if (input.checked) {
                input.setAttribute('checked', 'checked');
            } else {
                input.removeAttribute('checked');
            }
        } else {
            input.setAttribute('value', input.value);
        }

        // `textarea` タグの場合、`value` ではなく `innerHTML` に値を設定
        if (input.tagName.toLowerCase() === 'textarea') {
            input.innerHTML = input.value;
        }

        // placeholder を削除
        input.removeAttribute('placeholder');
    });

    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.open();
    printWindow.document.write(`
        <html>
            <head>
                <title>印刷</title>
                <style>
                    body { font-family: Arial, sans-serif; }
                    .center-form, .deliver-form, .itemlist {
                        margin-bottom: 20px;
                    }
                    .m-t30 { margin-top: 30px; }
                    .two-column {
                        display: flex;
                        justify-content: space-between;
                        gap: 20px;
                    }
                    .two-column > div {
                        flex: 1;
                        min-width: 200px;
                    }
                    .form-group, .deliver-group {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 20px;
                        margin-bottom: 5px;
                    }
                    .form-group label {
                        width: 70px;
                        font-size: 14px;
                    }
                    .deliver-group label {
                        width: 110px;
                        font-size: 14px;
                    }
                    .form-group input, .deliver-group input {
                        flex: 1;
                        min-width: 150px;
                    }
                    .orderbox {
                        width: 98%;
                    }
                    .item-list h3{
                        margin-bottom: 5px;
                    }
                    .item-list {
                        margin-top: 20px;
                        margin-bottom: 20px;
                    }
                    .item-row {
                        display: flex;
                        justify-content: space-between;
                        gap: 20px;
                        margin-bottom:5px;
                    }

                   .number {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                    
                </style>
            </head>
            <body onload="window.print(); window.close();">
            <h3 style="text-align:center;margin-bottom:5px;">FAX用紙</h3>
                ${printArea.innerHTML}
            </body>
        </html>
    `);
    printWindow.document.close();
}

function checkInput(textarea) {
    // 文字数のチェック
    if (textarea.value.length > 220) {
        textarea.value = textarea.value.substring(0, 220);
    }
    
    // 行数のチェック
    const lines = textarea.value.split('\n');
    if (lines.length > 4) {
        textarea.value = lines.slice(0, 4).join('\n'); // 4行以上の行を削除
    }
}